"use strict"

import axios from "axios";

const state = function() {
  return {
    loading: false,
    userInfoLoaded: false,
    userInfo: null
  };
};

const getters = {
  getSportMasterRole: state => {
    if (state.userInfo !== null) {
      return state.userInfo.role;
    }

    return 'nouserinfo'
  }
};

const mutations = {
  SET_USER_INFO: (state, payload) => {
    state.userInfo = payload;
  },

  SET_USERINFO_LOADED: (state, payload) => {
    state.userInfoLoaded = payload;
  },

  SET_LOADING: (state, payload) => {
    state.loading = payload;
  }
};

const actions = {
  async fetchUserInfo({ commit }) {
    commit("SET_LOADING", true);

    await axios.get(`/1.0/spec-private/sportmaster/users/current`)
      .then(x => {
        if (x.data.data !== undefined) {
          commit("SET_USER_INFO", x.data.data);
          commit("SET_USERINFO_LOADED", true);
        }
      })
      .finally(() => {
        commit("SET_LOADING", false);
      })
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
